export default __webpack_public_path__ + "static/media/1-min.c52fbff9.webp";